// log.service.ts
import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AmdocsAuthService } from 'amdocs-auth-package';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  authService: AmdocsAuthService = inject(AmdocsAuthService);
  userService = inject(UserService);
  http = inject(HttpClient);
  logFileName: number | undefined = undefined;

  private maxLogs = 500; // Limit number of logs to store
  private conversationID: BehaviorSubject<string> = new BehaviorSubject('');

  private httpOptionsHeaders(): any {
    return {
      headers: new HttpHeaders({
        'x-api-key': environment.apiKey,
        Authorization: this.authService.getToken(),
      })
    }
  }

  constructor(){
    this.logFileName = new Date().getTime();
  }

  log(message: any, conversationID: string = '') {
    const logs = JSON.parse(localStorage.getItem(`logs-${this.logFileName}`) || '[]');
    const now = new Date();
    const timestamp = formatDate(now, 'dd-MM-yy::hh:mm:ss:SSS a', 'en-US');;
    logs.push(`${message}|${timestamp}`);
    if (logs.length > this.maxLogs) {
      logs.shift(); // Remove oldest log if limit exceeded
    }
    if (conversationID) {
      this.conversationID.next(conversationID);
    }
    localStorage.setItem(`logs-${this.logFileName}`, JSON.stringify(logs));
  }

  getLogs() {
    return JSON.parse(localStorage.getItem(`logs-${this.logFileName}`) || '[]');
  }

  getConversationID(): BehaviorSubject<string> {
    return this.conversationID;
  }

  setConversationID(conversationID: string) {
    this.conversationID.next(conversationID);
  }

  clearLogs() {
    localStorage.removeItem(`logs-${this.logFileName}`);
  }

  setLogFileName(): void{
    this,this.logFileName = new Date().getTime();
  }

  uploadLogs(){
    const data = this.getLogs();
    this.clearLogs();
    this.setLogFileName();
    const logs: any = {
      metaData: {
        dlConversationId: this.conversationID?.value,
        dateTime: new Date().toISOString(),
        userId: this.userService.upn,
      },
      logsData: {data},
    }
    this.clearLogs();
     return this.http.post(`${environment.apiUrl}/bot/savelogs`,logs, this.httpOptionsHeaders());
    }
}
